import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import './Equipment.css';

const Equipment = () => {
  const [cart, setCart] = useState([]);
  const [showCheckout, setShowCheckout] = useState(false);
  const [status, setStatus] = useState("");

  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    city: ''
  });

  const [formErrors, setFormErrors] = useState({
    name: '',
    mobile: '',
    city: ''
  });
  
  const [validated, setValidated] = useState(false);

  const products = [
    {
      id: 1,
      name: '3 FUNCTION MOTORIZED BED',
      // description: 'Adjustable hospital bed with remote control for home care. Features include height adjustment, backrest adjustment, and leg rest adjustment.',
      price: 58000,
      image: '/images/equipments/3-function-bed-electric.jpg',
      mrp: 86500,
      available: true
    },
    {
      id: 2,
      name: '5 FUNCTION MOTORIZED BED',
      // description: 'Foldable wheelchair with comfortable seating and easy maneuverability. Perfect for indoor and outdoor use with durable construction.',
      price: 75000,
      image: '/images/equipments/5-function-icu-bed.jpeg',
      mrp: 101500,
      available: true
    },
    {
      id: 3,
      name: '2 FUNCTION MOTORIZED BED',
      // description: 'Portable oxygen concentrator for respiratory support at home. Provides continuous oxygen flow with adjustable settings.',
      price: 35000,
      image: '/images/equipments/2-function-m-bed.webp',
      available: true
    },
    {
      id: 4,
      name: 'BPL Oxygen Concentrator 10 Litre',
      // description: 'Multi-parameter patient monitor for vital signs monitoring. Tracks heart rate, blood pressure, oxygen saturation, and temperature.',
      price: 55000,
      image: '/images/equipments/10litre-bpl-oxygen-concentrator.jpg',
      mrp: 90500,
      available: true
    },
    {
      id: 5,
      name: 'Philips Oxygen Concentrator 5 Litre',
      // description: 'Compact nebulizer for respiratory medication delivery. Easy to use and clean with quiet operation.',
      price: 46000,
      image: '/images/equipments/Phillips-Oxygen-Concenterator.webp',
      mrp: 80400,
      available: true
    },
    {
      id: 6,
      name: 'DVT Pump',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 35000,
      image: '/images/equipments/dvt-pump.jpg',
      mrp: 82000,
      available: true
    },
    {
      id: 7,
      name: 'Yuwell Double Jar Electrical Section Machine',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 14000,
     image: '/images/equipments/yuwell_suction_image.avif',
      mrp: 35000,
      available: true
    },
    {
      id: 8,
      name: 'BMC Bipap Machine',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 28000,
      image: '/images/equipments/bmc-bpap.webp',
      mrp: 42000,
      available: true
    },
    {
      id: 9,
      name: 'Phillips Respironics Dreamstation',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 56400,
      image: '/images/equipments/reporonics.webp',
      mrp: 81000,
      available: true
    },
    {
      id: 10,
      name: 'BASIC MANUAL WHEELCHAIR (HBHC PLUS)',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 5000,
      image: '/images/equipments/Manual-Wheelchair.jpg',
      mrp: 7000,
      available: true
    },
    {
      id: 11,
      name: 'HEALING BELL COMMODE CHAIRMODEL CODE- (HBHC2001) PREMIUM SEGMENT',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 2000,
      image: '/images/equipments/commode_edited.jpg',
      mrp: 2500,
      available: true
    },
    {
      id: 12,
      name: 'HBHC HEALING BELL RECIPROCAL WALKER WITHOUT WHEELS (MODEL CODE- HBHC 1001R)',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 1500,
      image: '/images/equipments/walk_edited.jpg',
      mrp: 2000,
      available: true
    },
    {
      id: 13,
      name: 'HEALING BELL WALKER WITH WHEELS (MODEL NUMBER- HBH1001W)',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 2000,
      image: '/images/equipments/w-wheel_edited.jpg',
      mrp: 2500,
      available: true
    },
    {
      id: 14,
      name: 'Wheelchair with Self-Propelling Commode',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 6500,
      image: '/images/equipments/whellchair-self-propling.jpg',
      mrp: 7500,
      available: true 
    },
    {
      id: 15,
      name: 'Reclining Wheelchair with Commode ',
      // description: 'Adjustable height walker with foldable design for easy storage and transport. Provides stability and support for walking.',
      price: 15500,
      image: '/images/equipments/recliner-chair.webp',
      mrp: 17000,
      available: true
    }
    
  ];

  const handleAddToCart = (product) => {
    const existingItem = cart.find(item => item.id === product.id);
    
    if (existingItem) {
      setCart(cart.map(item => 
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  const handleRemoveFromCart = (productId) => {
    setCart(cart.filter(item => item.id !== productId));
  };

  const handleQuantityChange = (productId, newQuantity) => {
    if (newQuantity < 1) return;
    
    setCart(cart.map(item => 
      item.id === productId ? { ...item, quantity: newQuantity } : item
    ));
  };

  const calculateTotal = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const handleCheckout = () => {
    // Reset validation state when opening checkout modal
    setValidated(false);
    setFormErrors({
      name: '',
      mobile: '',
      city: ''
    });
    setShowCheckout(true);
  };

  const validateField = (name, value) => {
    let errorMessage = '';
    
    switch (name) {
      case 'name':
        if (!value.trim()) {
          errorMessage = 'Name is required';
        } else if (value.trim().length < 3) {
          errorMessage = 'Name must be at least 3 characters';
        }
        break;
        
      case 'mobile':
        if (!value.trim()) {
          errorMessage = 'Mobile number is required';
        } else if (!/^[0-9]{10}$/.test(value.replace(/[\s-]/g, ''))) {
          errorMessage = 'Please enter a valid 10-digit mobile number';
        }
        break;
        
      case 'city':
        if (!value.trim()) {
          errorMessage = 'Please select a city';
        }
        break;
        
      default:
        break;
    }
    
    setFormErrors(prevErrors => ({
      ...prevErrors,
      [name]: errorMessage
    }));
    
    return !errorMessage;
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Validate field as user types
    validateField(name, value);
  };

  const validateForm = () => {
    // Validate all fields
    const isNameValid = validateField('name', formData.name);
    const isMobileValid = validateField('mobile', formData.mobile);
    const isCityValid = validateField('city', formData.city);
    
    return isNameValid && isMobileValid && isCityValid;
  };

  const handleSubmitOrder = async (e) => {
    e.preventDefault();
    setValidated(true);
    
    // Custom validation
    if (!validateForm()) {
      return;
    }
    
    // Here you would typically send the order data to your backend
    const orderData = {
      type: '',
      subject: '',
      customer: formData,
      items: cart,
      total: calculateTotal()
    };
    try {
       const payload = {
        ...orderData,
        type: "equipment",        // or "services" / "equipment"
        subject: "Equipment Order", // you can make this dynamic if needed
        timestamp: new Date().getTime() // ensures uniqueness
      };
      const res = await fetch("https://script.google.com/macros/s/AKfycbxh0G5IHnJDGHNY9AyZakh0Mr9LWpPT4dO67qGJPsUAaMNXeKj1F4U75rQGBp83g8sRDg/exec", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setStatus("Message sent successfully!");
         alert('Your order has been submitted successfully!');
        console.log(res);
      } else {
        setStatus("Failed to send message.");
         console.log(res);
      }
    } catch (error) {
      setStatus("Error: " + error.message);
       console.log(status);
    }
    
    // Reset cart and form after submission
    setCart([]);
    setFormData({
      name: '',
      mobile: '',
      city: ''
    });
    setShowCheckout(false);
    
   
  };

  return (
    <div className="equipment-section" id="equipment">
     
      <Container>
        <div className="section-header text-center">
          <h2>Medical Equipment</h2>
          <p>Quality medical equipment for home healthcare needs</p>
        </div>

        <Row className="equipment-container">
          <Col lg={8} md={7} className="product-list">
            <Row>
              {products.map((product) => (
                <Col lg={6} md={6} sm={12} key={product.id} className="mb-4">
                  <Card className="product-card h-100">
                    <div className="product-image">
                      <img src={product.image} alt={product.name} />
                      {product.available ? (
                        <span className="badge bg-success availability-badge">In Stock</span>
                      ) : (
                        <span className="badge bg-danger availability-badge">Out of Stock</span>
                      )}
                    </div>
                    <Card.Body>
                      <Card.Title className="product-title">{product.name}</Card.Title>
                      <Card.Text className="product-description">{product.description}</Card.Text>
                      <div className="product-price">
                        {product.mrp && (
                          <span className="product-mrp">₹{product.mrp.toLocaleString()}</span>
                        )}
                        ₹{product.price.toLocaleString()}
                      </div>
                      <div className="product-actions">
                        <div className="quantity-selector">
                          <Button 
                            variant="outline-secondary" 
                            size="sm" 
                            className="quantity-btn"
                            onClick={() => {
                              const existingItem = cart.find(item => item.id === product.id);
                              if (existingItem) {
                                handleQuantityChange(product.id, existingItem.quantity - 1);
                              }
                            }}
                            disabled={!cart.find(item => item.id === product.id)}
                          >
                            -
                          </Button>
                          <span className="quantity-display">
                            {cart.find(item => item.id === product.id)?.quantity || 0}
                          </span>
                          <Button 
                            variant="outline-secondary" 
                            size="sm" 
                            className="quantity-btn"
                            onClick={() => handleAddToCart(product)}
                            disabled={!product.available}
                          >
                            +
                          </Button>
                        </div>
                        <Button 
                          className="add-to-cart-btn" 
                          onClick={() => handleAddToCart(product)}
                          disabled={!product.available}
                        >
                          Add to Cart
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
          
          <Col lg={4} md={5} className="cart-container">
            <Card className="cart-card">
              <Card.Body>
                <Card.Title className="cart-title">Your Cart</Card.Title>
                {cart.length === 0 ? (
                  <div className="empty-cart">
                    <i className="fas fa-shopping-cart"></i>
                    <p>Your cart is empty</p>
                  </div>
                ) : (
                  <>
                    <div className="cart-items">
                      {cart.map((item) => (
                        <div className="cart-item" key={item.id}>
                          <div className="cart-item-image">
                            <img src={item.image} alt={item.name} />
                          </div>
                          <div className="cart-item-details">
                            <h5>{item.name}</h5>
                            <div className="cart-item-price">
                              {item.mrp && (
                                <span className="cart-item-mrp">₹{item.mrp.toLocaleString()}</span>
                              )}
                              ₹{item.price.toLocaleString()}
                            </div>
                            <div className="cart-item-actions">
                              <div className="cart-quantity">
                                <Button 
                                  variant="outline-secondary" 
                                  size="sm" 
                                  className="quantity-btn"
                                  onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                                >
                                  -
                                </Button>
                                <span className="quantity-display">{item.quantity}</span>
                                <Button 
                                  variant="outline-secondary" 
                                  size="sm" 
                                  className="quantity-btn"
                                  onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                                >
                                  +
                                </Button>
                              </div>
                              <Button 
                                variant="outline-danger" 
                                size="sm" 
                                className="remove-btn"
                                onClick={() => handleRemoveFromCart(item.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="cart-summary">
                      <div className="cart-total">
                        <span>Total:</span>
                        <span>₹{calculateTotal().toLocaleString()}</span>
                      </div>
                      <Button 
                        className="checkout-btn" 
                        onClick={handleCheckout}
                        disabled={cart.length === 0}
                      >
                        Proceed to Checkout
                      </Button>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Checkout Modal */}
      <Modal show={showCheckout} onHide={() => setShowCheckout(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Complete Your Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <h5>Order Summary</h5>
              <div className="checkout-items">
                {cart.map((item) => (
                  <div className="checkout-item" key={item.id}>
                    <div className="checkout-item-name">
                      {item.name} <span className="checkout-item-quantity">x{item.quantity}</span>
                    </div>
                    <div className="checkout-item-price">₹{(item.price * item.quantity).toLocaleString()}</div>
                  </div>
                ))}
                <div className="checkout-total">
                  <span>Total Amount:</span>
                  <span>₹{calculateTotal().toLocaleString()}</span>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <h5>Your Information</h5>
              <Form onSubmit={handleSubmitOrder} noValidate validated={validated}>
                  <Form.Group className="mb-3">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleFormChange}
                      placeholder="Enter your full name"
                      isInvalid={validated && !!formErrors.name}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.name || 'Please enter your full name'}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleFormChange}
                      placeholder="Enter your mobile number"
                      isInvalid={validated && !!formErrors.mobile}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.mobile || 'Please enter your mobile number'}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <Form.Select
                      name="city"
                      value={formData.city}
                      onChange={handleFormChange}
                      isInvalid={validated && !!formErrors.city}
                      required
                    >
                      <option value="">Select your city</option>
                      <option value="Bangalore">Bangalore</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {formErrors.city || 'Please select your city'}
                    </Form.Control.Feedback>
                  </Form.Group>
                <div className="text-center mt-4">
                  <Button type="submit" className="order-submit-btn">Place Order</Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Equipment;